import axios from 'axios'

const instance = axios.create({
    baseURL:'https://mini-url-backend.herokuapp.com/'
})

export default instance